import React, {useState} from "react"
import _ from "lodash"

import Data from "../../data"

import {Button, Link} from "../controls"
import {Redirect} from "react-router-dom"

import "./RelatedActivities.scss"

function RelatedActivity({activity}) {
  // the image
  let image = Data.Activity.getDefaultImage(activity)

  // render
  return (
    <div className="item">
      <div className="item-inner">
        <div className="image">
          <Link to={`/activity/${activity.slug}`}>
            <img src={image.url_thumbnail || image.url} alt={activity.title} />
          </Link>
        </div>
        <div className="title">
          <Link to={`/activity/${activity.slug}`}>
            {activity.title}
          </Link>
        </div>
      </div>
    </div>
  )
}

function RelatedActivities({title, activity, adventure}) {
  const [redirectToSearch, setRedirectToSearch] = useState(false)

  let activity_items = activity ? Data.Catalogue.getSimilar(activity._id, 5) : []
  let adventure_items = adventure ? Data.Catalogue.getUpsells(adventure, 2) : []
  
  let activities = _.concat(activity_items, adventure_items)

  // redirect to search? 
  if(redirectToSearch) {
    return <Redirect to="/" />
  }

  // get sub-components
  let items = activities.map(a => <RelatedActivity key={a._id} activity={a} kind="suggestion" />)
  
  // render
  return (
    <div className="c-related-activities">
      <h2>{title}</h2>
      <div className="items">
        {items}
      </div>
      <div className="back-to-search">
        <Button kind="ok" onClick={() => setRedirectToSearch(true)} wide={true}>Alle Erlebnisse anzeigen</Button>
      </div>
    </div>
  )
}

export default RelatedActivities